import { render } from "./meusPedidos.vue?vue&type=template&id=3b898868&scoped=true"
import script from "./meusPedidos.vue?vue&type=script&lang=js"
export * from "./meusPedidos.vue?vue&type=script&lang=js"

import "./meusPedidos.vue?vue&type=style&index=0&id=3b898868&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\sensualle\\sensualle - pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b898868"]])

export default __exports__